// Product card: keep MRP and savings in sync with the selected weight pill.
// theme.js already swaps the variant id and main price; this handles the rest.
document.addEventListener('click',e=>{
  const b=e.target.closest('[data-card] [data-weight-row] .w-btn');
  if(!b)return;
  const card=b.closest('[data-card]');
  const was=card.querySelector('[data-price-was]');
  const save=card.querySelector('[data-price-save]');
  const s=b.dataset.save,c=b.dataset.compare;
  if(was){if(s){was.textContent='₹'+c;was.hidden=false}else{was.hidden=true}}
  if(save){if(s){save.textContent='Save ₹'+s;save.hidden=false}else{save.hidden=true}}
});
